import { PlusIcon, XIcon } from '@phosphor-icons/react';
import { css, html } from 'react-strict-dom';
import { Api, useApiCallable } from 'src/api';
import { Avatar, Dropdown, Stack, Text } from 'src/components';
import { Color, Style } from 'src/constants';
import { Model } from 'src/models';

type Props = {
  skill: Api.TicketSkill.V;
  agencyUsers: ReadonlyArray<Api.User.BaseView>;
  invalidate: () => void;
};

export default function SkillAssigneeDropdown({
  skill,
  agencyUsers,
  invalidate,
}: Props) {
  const callApi = useApiCallable();

  const { assignee } = skill;
  // The API refuses a new assignee until the skill is approved, though whoever
  // is already on it can still be taken off.
  const available = Model.TicketSkill.isAssignable(skill)
    ? agencyUsers.filter((u) => u.id !== assignee?.id)
    : [];

  async function handleSetAssignee(userIri: string | null) {
    await callApi(`/ticket-skills/${skill.id}`, {
      method: 'PATCH',
      jsonBody: { assignee: userIri },
    });
    invalidate();
  }

  return (
    <html.div style={styles.container}>
      {assignee && (
        <>
          <Dropdown.SectionHeader>Assigned</Dropdown.SectionHeader>
          <Dropdown.Row onClick={() => handleSetAssignee(null)}>
            <Avatar user={assignee} size={32} />
            <Stack style={Style.fill}>
              <Text>
                {assignee.firstName} {assignee.lastName}
              </Text>
            </Stack>
            <XIcon size={16} color={Color.neutral60} />
          </Dropdown.Row>
        </>
      )}

      {available.length > 0 && (
        <>
          <Dropdown.SectionHeader>
            {assignee ? 'Change Assignee' : 'Select Assignee'}
          </Dropdown.SectionHeader>
          {available.map((user) => (
            <Dropdown.Row
              key={user.id}
              onClick={() => handleSetAssignee(user['@id'])}
            >
              <Avatar user={user} size={32} />
              <Stack style={Style.fill}>
                <Text>
                  {user.firstName} {user.lastName}
                </Text>
              </Stack>
              <PlusIcon size={16} color={Color.neutral60} />
            </Dropdown.Row>
          ))}
        </>
      )}
    </html.div>
  );
}

const styles = css.create({
  container: {
    width: 270,
  },
});
